// Shared by the dashboard phone controls and the Salesforce CTI panel: once a
// transfer is under way the store only knows the dialled number, but the agent
// needs to see who that is.
export function transferTargetLabel(agents, target) {
  if (!target) return '';
  const match = (agents || []).find(agent => agent.phone_username === target);
  const name = match?.name || match?.email;
  return name ? `${target} ${name}` : target;
}

export default { transferTargetLabel };
